'use strict';

/* eslint no-inline-comments: off */

const sports = [
  // Extracted from "profile.xls" contained in FitSDKRelease_20.66.00
  'Generic', // 0
  'Running', // 1
  'Cycling', // 2
  'Transition', // 3 (Multi-sport transition)
  'Fitness_equipment', // 4
  'Swimming', // 5
  'Basketball', // 6
  'Soccer', // 7
  'Tennis', // 8
  'American_football', // 9
  'Training', // 10
  'Walking', // 11
  'Cross_country_skiing', // 12
  'Alpine_skiing', // 13
  'Snowboarding', // 14
  'Rowing', // 15
  'Mountaineering', // 16
  'Hiking', // 17
  'Multisport', // 18
  'Paddling', // 19
  'Flying', // 20
  'E_biking', // 21
  'Motorcycling', // 22
  'Boating', // 23
  'Driving', // 24
  'Golf', // 25
  'Hang_gliding', // 26
  'Horseback_riding', // 27
  'Hunting', // 28
  'Fishing', // 29
  'Inline_skating', // 30
  'Rock_climbing', // 31
  'Sailing', // 32
  'Ice_skating', // 33
  'Sky_diving', // 34
  'Snowshoeing', // 35
  'Snowmobiling', // 36
  'Stand_up_paddleboarding', // 37
  'Surfing', // 38
  'Wakeboarding', // 39
  'Water_skiing', // 40
  'Kayaking', // 41
  'Rafting', // 42
  'Windsurfing', // 43
  'Kitesurfing', // 44
  'Tactical', // 45
  'Jumpmaster', // 46
  'Boxing', // 47
  'Floor_climbing', // 48
  'Biking', // 49
  'training', // 50
  'All', // 254 (All is for goals only to include all sports)
];

module.exports = sports;
